import React from "react";
import "./HeroOverview.css";
import { useNavigate } from "react-router-dom";
export default function HeroOverview() {
  const navigate = useNavigate();
  return (
    <section className="herooverview" id="herooverview">
      {/* ✅ Overlay for better contrast */}
      <div className="herooverview-overlayoverview"></div>
      <div className="herooverview-contentoverview">
        <h1>Glamur Paints Product Range</h1>
        <h2>Complete Wall Paint Solutions for Pakistan</h2>
        <button className="ctaoverview-btnoverview" onClick={() => navigate("/e-store")}>
          BUY YOUR FAVOURITE PAINTS NOW!
        </button>
      </div>
    </section>
  );
}
